/* eslint-disable react-refresh/only-export-components */
import { createContext, ReactNode, useContext, useState } from 'react';
import { ApplicationConfiguration } from '../api/application_configuration';
import { LinkUrl } from '../types/model/linkUrl';

interface ConfigurationContextType {
  applicationConfiguration: ApplicationConfiguration;
  linkUrls: LinkUrl[];
  updateConfiguration: (config: ApplicationConfiguration, urls: LinkUrl[]) => void;
}

const ConfigurationContext = createContext<ConfigurationContextType | undefined>(undefined);

export function ConfigurationProvider({ children }: { children: ReactNode }) {
  const [applicationConfiguration, setApplicationConfiguration] =
    useState<ApplicationConfiguration | null>(null);
  const [linkUrls, setLinkUrls] = useState<LinkUrl[]>([]);

  const updateConfiguration = (config: ApplicationConfiguration, urls: LinkUrl[]) => {
    setApplicationConfiguration(config);
    setLinkUrls(urls);
    if (config.application_configuration.application_name) {
      document.title = `${config.application_configuration.application_name} | 管理者`;
    }
    // if (config.application_configuration?.logo_image?.url) {
    //   const faviconTags: HTMLLinkElement[] = Array.from(
    //     document.querySelectorAll("link[rel*='icon']")
    //   );
    //   if (faviconTags) {
    //     faviconTags.forEach((faviconTag) => {
    //       faviconTag.href = config.application_configuration.logo_image.url;
    //     });
    //   }
    // }
  };

  return (
    <ConfigurationContext.Provider
      value={{
        applicationConfiguration,
        linkUrls,
        updateConfiguration,
      }}
    >
      {children}
    </ConfigurationContext.Provider>
  );
}

export function useConfiguration() {
  const context = useContext(ConfigurationContext);
  if (context === undefined) {
    throw new Error('useConfiguration must be used within a ConfigurationProvider');
  }
  return context;
}
